export default __webpack_public_path__ + "static/alan-7dbff3a72bbef2918fbcc789358b6ede.jpg";